/* eslint-disable @atlassian/relay/unused-fields */
import { graphql } from 'react-relay';

// eslint-disable-next-line @atlassian/relay/must-use-inline
export const NativeConfigEnabled = graphql`
	query NativeConfigEnabledQuery($jiraProjectAri: ID!) {
		jsmChat {
			initializeNativeConfig(jiraProjectAri: $jiraProjectAri) {
				nativeConfigEnabled
				connectedApp
			}
		}
	}
`;
